(function () {
  var config = window.DairyAssureRedditPixel || {};
  var cartState = config.cart || null;
  var checkoutTracked = false;

  function canTrack() {
    return typeof window.rdt === 'function';
  }

  function conversionId(eventName) {
    var prefix = String(eventName || 'reddit').toLowerCase().replace(/[^a-z0-9]+/g, '-');

    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return prefix + '-' + window.crypto.randomUUID();
    }

    return prefix + '-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function track(eventName, payload) {
    if (!canTrack()) return;
    var eventPayload = Object.assign({}, payload || {});
    if (!eventPayload.conversionId) {
      eventPayload.conversionId = conversionId(eventName);
    }
    window.rdt('track', eventName, eventPayload);
  }

  function centsToAmount(value) {
    var amount = Number(value || 0);
    return Number.isFinite(amount) ? amount / 100 : 0;
  }

  function cartItemPayload(item) {
    if (!item) return {};

    var quantity = Number(item.quantity || 1);
    var price = centsToAmount(item.final_price || item.price || item.presentment_price);

    return {
      currency: config.currency || 'USD',
      itemCount: quantity,
      products: [
        {
          id: String(item.variant_id || item.id || ''),
          name: item.product_title || item.title || 'DairyAssure',
          quantity: quantity,
          item_price: price
        }
      ],
      value: price * quantity
    };
  }

  function cartPayload(cart) {
    if (!cart) {
      return {
        currency: config.currency || 'USD'
      };
    }

    var items = Array.isArray(cart.items) ? cart.items : [];

    if (items.length > 0) {
      var products = items.map(function (item) {
        return {
          id: String(item.variant_id || item.id || ''),
          name: item.product_title || item.title || 'DairyAssure',
          quantity: Number(item.quantity || 1),
          item_price: centsToAmount(item.final_price || item.price || item.presentment_price)
        };
      });

      return {
        currency: cart.currency || config.currency || 'USD',
        itemCount: items.reduce(function (total, item) {
          return total + Number(item.quantity || 0);
        }, 0),
        products: products,
        value: centsToAmount(cart.total_price)
      };
    }

    return {
      currency: cart.currency || config.currency || 'USD',
      itemCount: Number(cart.itemCount || 0),
      products: cart.products || [],
      value: Number(cart.value || 0)
    };
  }

  function refreshCartState() {
    if (typeof window.fetch !== 'function') return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) cartState = cart;
      })
      .catch(function () {});
  }

  function trackProductView() {
    if (!config.product) return;
    track('ViewContent', config.product);
  }

  function trackAddToCart(event) {
    if (!event || event.source !== 'product-form') return;

    var item = event && event.cartData;
    if (item) cartState = cartItemPayload(item);
    track('AddToCart', cartItemPayload(item));
    refreshCartState();
  }

  function trackInitiateCheckout() {
    if (checkoutTracked) return;
    checkoutTracked = true;
    track('Custom', Object.assign({ customEventName: 'InitiateCheckout' }, cartPayload(cartState)));
  }

  function isCheckoutTrigger(element) {
    if (!element || !element.closest) return false;

    return Boolean(
      element.closest('button[name="checkout"], input[name="checkout"], [formaction*="/checkout"], a[href*="/checkout"]')
    );
  }

  function trackSearchSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/search"], form[action*="search"]')) return;

    var field = form.querySelector('input[name="q"], input[type="search"]');
    var query = field ? field.value : '';
    track('Search', { search_string: query || undefined });
  }

  function trackLead(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/contact"], form[action*="contact"]')) return;
    if (!form.querySelector('input[name="contact[tags]"][value*="newsletter"]')) return;

    track('Lead', { customEventName: 'NewsletterSignup' });
  }

  function bindThemeEvents() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, trackAddToCart);
    }

    document.addEventListener('submit', function (event) {
      trackSearchSubmit(event);
      trackLead(event);

      var submitter = event.submitter;
      if (isCheckoutTrigger(submitter) || event.target.matches('form[action*="/checkout"]')) {
        trackInitiateCheckout();
      }
    });

    document.addEventListener(
      'click',
      function (event) {
        if (isCheckoutTrigger(event.target)) trackInitiateCheckout();
      },
      true
    );
  }

  refreshCartState();
  trackProductView();
  bindThemeEvents();
})();
